// extracted by mini-css-extract-plugin
module.exports = {"pager":"pager-module--pager--1pyVq","current":"pager-module--current--2gnt4","prev":"pager-module--prev--1Oss8","next":"pager-module--next--2qUMX"};